module.exports = __webpack_public_path__ + "static/media/irancell-logo.b930ca56.svg";